customElements.get("vanilla-slider") || customElements.define("vanilla-slider", class extends HTMLElement {
  constructor() {
    super(), this.slider = this.querySelector("[data-slider]"), this.slides = this.querySelectorAll("[data-slide]"), 
    this.prev = this.querySelectorAll("[data-prev]"), this.next = this.querySelectorAll("[data-next]"), 
    this.nav = this.querySelectorAll("[data-nav]"), this.animate = this.hasAttribute("data-animate"), 
    this.loop = this.hasAttribute("data-loop"), this.realSlideCount = this.slides.length, 
    this.loopOffset = 0, this.crawl = this.hasAttribute("data-crawl"), this.crawlSpeed = Number(this.dataset.crawlSpeed) || 60, 
    this.crawlRafId = null, this.isCrawling = !1, this.crawlStarted = !1, this.viewportObserver = null, 
    this.enableDrag = this.hasAttribute("data-enable-drag") && "false" !== this.dataset.enableDrag, 
    this.autoplay = Number(1e3 * this.dataset.autoplay || 0), this.autoplay && (this.autoplay, 
    parseInt(getComputedStyle(document.documentElement).getPropertyValue("--duration"))), 
    this.autoplayIndex = 0, this.interval, this.isRepositioning = !1, this.isVertical = this.slider?.classList.contains("slider-y") || !1, 
    this.isDragging = !1, this.startX = 0, this.startY = 0, this.dragStartScroll = 0, 
    this.originalScrollSnapType = null, this.originalScrollBehavior = null, this.dragged = !1, 
    this.velocity = 0, this.lastMoveTime = 0, this.lastMovePos = 0, this.progress = this.querySelector("[data-progress]"), 
    this.progressInner = this.progress?.querySelector("div"), this.boundHandleDragMove = this.handleDragMove.bind(this), 
    this.boundHandleDragEnd = this.handleDragEnd.bind(this);
  }
  connectedCallback() {
    if (!this.slider) return !1;
    this.originalScrollSnapType = getComputedStyle(this.slider).scrollSnapType, this.originalScrollBehavior = getComputedStyle(this.slider).scrollBehavior, 
    this.loop && this.setupLoop();
    const t = () => {
      const t = this.loop ? this.loopOffset * this.getSlideSize() : 0, s = this.isVertical ? this.slider.scrollTop : this.slider.scrollLeft;
      Math.abs(s - t) > 1 && (this.slider.style.scrollBehavior = "auto", this.slider.style.scrollSnapType = "none", 
      this.isVertical ? this.slider.scrollTop = t : this.slider.scrollLeft = t, requestAnimationFrame(() => {
        this.isCrawling || (this.slider.style.scrollBehavior = "", this.slider.style.scrollSnapType = "");
      }));
    };
    t(), setTimeout(t, 100), window.addEventListener("load", t), this.addEventListeners(), 
    this.progressInner && (this.progressInner.style.width = 100 / this.realSlideCount + "%"), 
    window.addEventListener("load", () => this.update()), document.addEventListener("DOMContentLoaded", () => this.update()), 
    this.enableDrag && (this.slider.style.cursor = "grab"), this.autoplay && (this.interval = setInterval(() => {
      this.autoplayIndex = this.autoplayIndex + 1 > this.realSlideCount - 1 ? 0 : this.autoplayIndex + 1, 
      this.goTo(this.autoplayIndex);
    }, this.autoplay)), this.crawl && window.addEventListener("load", () => this.startCrawl(), {
      once: !0
    }), (this.autoplay || this.crawl) && (this.viewportObserver = new IntersectionObserver(t => {
      t.forEach(t => {
        t.isIntersecting ? this.resumeMotion() : this.pauseMotion();
      });
    }), this.viewportObserver.observe(this));
  }
  disconnectedCallback() {
    this.pauseMotion(), this.viewportObserver?.disconnect(), this.viewportObserver = null;
  }
  pauseMotion() {
    this.interval && (clearInterval(this.interval), this.interval = null), this.isCrawling && (cancelAnimationFrame(this.crawlRafId), 
    this.crawlRafId = null, this.isCrawling = !1);
  }
  resumeMotion() {
    this.autoplay && !this.interval && (this.interval = setInterval(() => {
      this.autoplayIndex = this.autoplayIndex + 1 > this.realSlideCount - 1 ? 0 : this.autoplayIndex + 1, 
      this.goTo(this.autoplayIndex);
    }, this.autoplay)), this.crawl && this.crawlStarted && !this.isCrawling && this.startCrawl();
  }
  getSlideSize() {
    if (this.isVertical) {
      const t = [ ...this.slides ].find(t => t.offsetHeight > 0);
      if (!t) return this.slider.offsetHeight;
      const s = parseInt(getComputedStyle(this.slider).getPropertyValue("gap").split(" ")[0]) || 0;
      return t.offsetHeight + s;
    }
    {
      const t = [ ...this.slides ].find(t => t.offsetWidth > 0);
      if (!t) return this.slider.offsetWidth;
      const s = parseInt(getComputedStyle(this.slider).getPropertyValue("gap").split(" ")[0]) || 0;
      return t.offsetWidth + s;
    }
  }
  scroll(t, s = !1) {
    s && (s.preventDefault(), s.stopPropagation()), this.isCrawling && this.stopCrawl();
    const i = this.getSlideSize(), e = "prev" === t ? -i : i;
    this.isVertical ? this.slider.scrollBy({
      top: e,
      behavior: "smooth"
    }) : this.slider.scrollBy({
      left: e,
      behavior: "smooth"
    });
  }
  goTo(t, s = "smooth") {
    this.isCrawling && this.stopCrawl();
    const i = this.loop ? parseInt(t) + this.loopOffset : parseInt(t), e = this.getSlideSize() * i;
    this.isVertical ? this.slider.scrollTo({
      top: e,
      behavior: s
    }) : this.slider.scrollTo({
      left: e,
      behavior: s
    });
  }
  hideArrow(t) {
    t.disabled = !0, t.ariaDisabled = !0;
  }
  showArrow(t) {
    t.disabled = !1, t.ariaDisabled = !1;
  }
  updateArrows() {
    if (this.loop) return this.prev.forEach(t => this.showArrow(t)), void this.next.forEach(t => this.showArrow(t));
    const t = this.isVertical ? this.slider.scrollTop : this.slider.scrollLeft, s = this.isVertical ? this.slider.offsetHeight : this.slider.offsetWidth, i = this.isVertical ? this.slider.scrollHeight : this.slider.scrollWidth;
    parseInt(getComputedStyle(document.documentElement).getPropertyValue("--spacing-offset")), 
    this.prev.forEach(s => t > 1 ? this.showArrow(s) : this.hideArrow(s)), this.next.forEach(e => t + s < i - 1 ? this.showArrow(e) : this.hideArrow(e));
  }
  updateNav() {
    const t = this.getIndex();
    this.nav.forEach(s => {
      s.querySelectorAll("button").forEach((s, i) => {
        if (s.ariaCurrent = i === t ? "true" : "false", this.animate) {
          const e = s.querySelector("span");
          if (!e) return;
          e.classList.remove("w-full", "duration-[var(--delay)]", "transition-all"), i === t ? e.classList.add("w-full", "duration-[var(--delay)]", "transition-all") : e.classList.add("w-0");
        }
      });
    });
  }
  updateProgress() {
    if (!this.progressInner || this.realSlideCount <= 1) return;
    const t = this.getSlideSize();
    if (0 === t) return;
    const s = this.isVertical ? this.slider.scrollTop : this.slider.scrollLeft;
    let i;
    i = this.loop ? ((s / t - this.loopOffset) % this.realSlideCount + this.realSlideCount) % this.realSlideCount : s / t;
    const e = i / this.realSlideCount * 100;
    this.progressInner.style.setProperty("--progress", `${e}%`);
  }
  getIndex() {
    const t = this.getSlideSize();
    if (0 === t) return 0;
    const s = this.isVertical ? this.slider.scrollTop : this.slider.scrollLeft, i = Math.round(s / t);
    return this.loop ? ((i - this.loopOffset) % this.realSlideCount + this.realSlideCount) % this.realSlideCount : i;
  }
  update() {
    this.updateArrows(), this.updateProgress(), setTimeout(() => this.updateNav(), 50);
  }
  smoothScrollTo(t, s) {
    return new Promise(i => {
      const e = this.isVertical ? this.slider.scrollTop : this.slider.scrollLeft, r = t - e;
      let l = null;
      const o = a => {
        null === l && (l = a);
        const h = a - l, n = Math.min(h / s, 1), d = (c = n) < .5 ? 4 * c * c * c : (c - 1) * (2 * c - 2) * (2 * c - 2) + 1;
        var c;
        const p = e + r * d;
        this.isVertical ? this.slider.scrollTop = p : this.slider.scrollLeft = p, h < s ? requestAnimationFrame(o) : (this.isVertical ? this.slider.scrollTop = t : this.slider.scrollLeft = t, 
        i());
      };
      requestAnimationFrame(o);
    });
  }
  getDragTargetIndex() {
    const t = this.getSlideSize();
    if (0 === t) return 0;
    const s = this.isVertical ? this.slider.scrollTop : this.slider.scrollLeft, i = s - .5 * this.velocity;
    let e = Math.round(i / t);
    Math.abs(this.velocity) < 200 && (e = Math.round(s / t));
    const r = this.slides.length;
    return Math.max(0, Math.min(e, r - 1));
  }
  handleDragStart(t) {
    this.enableDrag && (this.isCrawling && this.stopCrawl(), this.dragged = !1, t.preventDefault(), 
    this.isDragging = !0, this.slider.style.cursor = "grabbing", this.slider.classList.add("dragging"), 
    this.slider.style.scrollSnapType = "none", this.slider.style.scrollBehavior = "auto", 
    this.slider.style.userSelect = "none", this.isVertical ? (this.startY = t.pageY - this.slider.offsetTop, 
    this.dragStartScroll = this.slider.scrollTop) : (this.startX = t.pageX - this.slider.offsetLeft, 
    this.dragStartScroll = this.slider.scrollLeft), this.velocity = 0, this.lastMoveTime = performance.now(), 
    this.lastMovePos = this.isVertical ? t.pageY : t.pageX, this.autoplay && clearInterval(this.interval), 
    document.addEventListener("mousemove", this.boundHandleDragMove, {
      passive: !1
    }), document.addEventListener("mouseup", this.boundHandleDragEnd, {
      once: !0
    }));
  }
  handleDragMove(t) {
    if (!this.isDragging) return;
    let s;
    this.dragged = !0, t.preventDefault(), this.isVertical ? (s = 2 * (t.pageY - this.slider.offsetTop - this.startY), 
    this.slider.scrollTop = this.dragStartScroll - s) : (s = 2 * (t.pageX - this.slider.offsetLeft - this.startX), 
    this.slider.scrollLeft = this.dragStartScroll - s);
    const i = performance.now(), e = i - this.lastMoveTime, r = this.isVertical ? t.pageY : t.pageX, l = r - this.lastMovePos;
    if (e > 16) {
      const t = 1e3 * l / (1 + e);
      this.velocity = .8 * t + .2 * this.velocity, this.lastMoveTime = i, this.lastMovePos = r;
    }
  }
  async handleDragEnd() {
    if (!this.isDragging) return;
    this.isDragging = !1, this.slider.classList.remove("dragging"), this.slider.style.cursor = "grab", 
    this.slider.style.userSelect = "";
    const t = this.getSlideSize(), s = this.getDragTargetIndex() * t;
    await this.smoothScrollTo(s, 400), this.slider.style.scrollSnapType = this.originalScrollSnapType, 
    this.slider.style.scrollBehavior = this.originalScrollBehavior, document.removeEventListener("mousemove", this.boundHandleDragMove), 
    this.update(), this.loop && this.handleLoopReposition(), this.autoplay && (this.interval = setInterval(() => {
      this.autoplayIndex = this.autoplayIndex + 1 > this.realSlideCount - 1 ? 0 : this.autoplayIndex + 1, 
      this.goTo(this.autoplayIndex);
    }, this.autoplay));
  }
  addEventListeners() {
    this.prev.forEach(t => t.addEventListener("click", t => this.scroll("prev", t))), 
    this.next.forEach(t => t.addEventListener("click", t => this.scroll("next", t))), 
    this.nav.forEach(t => t.querySelectorAll("button").forEach((t, s) => t.addEventListener("click", () => this.goTo(s)))), 
    this.autoplay && [ "wheel", "touchmove", "click" ].forEach(t => {
      this.addEventListener("click", () => clearInterval(this.interval), {
        once: !0
      });
    }), this.crawl && [ "wheel", "touchstart", "pointerdown" ].forEach(t => {
      this.slider.addEventListener(t, () => {
        this.isCrawling && this.stopCrawl();
      }, {
        once: !0,
        passive: !0
      });
    }), this.enableDrag && (this.slider.addEventListener("mousedown", t => this.handleDragStart(t)), 
    this.slider.addEventListener("click", t => {
      this.dragged && (t.preventDefault(), t.stopPropagation());
    }, {
      capture: !0
    }));
    const t = new IntersectionObserver(t => {
      t.forEach(t => t.target.ariaCurrent = t.isIntersecting);
    }, {
      root: this.slider,
      threshold: .8
    });
    this.slides.forEach(s => t.observe(s)), new MutationObserver(() => {
      this.slides = this.querySelectorAll("[data-slide]"), t.disconnect(), this.slides.forEach(s => t.observe(s)), 
      this.update();
    }).observe(this.slider, {
      childList: !0
    }), this.slider.addEventListener("scroll", () => {
      this.updateProgress(), this.isDragging || this.isCrawling || this.update();
    }, {
      passive: !0
    }), this.slider.addEventListener("scrollend", () => {
      this.isCrawling || this.isDragging || (this.update(), this.loop && this.handleLoopReposition());
    }, {
      passive: !0
    });
  }
  setupLoop() {
    if (this.realSlideCount <= 1) return void (this.loop = !1);
    const t = [ ...this.slides ];
    this.loopOffset = this.realSlideCount, t.forEach(t => {
      const s = t.cloneNode(!0);
      s.setAttribute("data-clone", ""), s.setAttribute("aria-hidden", "true"), s.removeAttribute("id"), 
      s.querySelectorAll("[id]").forEach(t => t.removeAttribute("id")), this.slider.appendChild(s);
    }), [ ...t ].reverse().forEach(t => {
      const s = t.cloneNode(!0);
      s.setAttribute("data-clone", ""), s.setAttribute("aria-hidden", "true"), s.removeAttribute("id"), 
      s.querySelectorAll("[id]").forEach(t => t.removeAttribute("id")), this.slider.prepend(s);
    }), this.slides = this.querySelectorAll("[data-slide]");
  }
  handleLoopReposition() {
    if (this.isRepositioning || this.isDragging) return;
    const t = this.getSlideSize();
    if (0 === t) return;
    const s = this.isVertical ? this.slider.scrollTop : this.slider.scrollLeft, i = Math.round(s / t);
    if (i < this.loopOffset || i >= this.loopOffset + this.realSlideCount) {
      this.isRepositioning = !0;
      const s = ((i - this.loopOffset) % this.realSlideCount + this.realSlideCount) % this.realSlideCount + this.loopOffset;
      this.slider.style.scrollBehavior = "auto", this.slider.style.scrollSnapType = "none", 
      this.isVertical ? this.slider.scrollTop = s * t : this.slider.scrollLeft = s * t, 
      requestAnimationFrame(() => {
        this.slider.style.scrollBehavior = "", this.slider.style.scrollSnapType = "", this.isRepositioning = !1;
      });
    }
  }
  startCrawl() {
    if (this.realSlideCount <= 1) return;
    this.isCrawling = !0, this.crawlStarted = !0, this.slider.style.scrollSnapType = "none", 
    this.slider.style.scrollBehavior = "auto";
    let t = null, s = this.isVertical ? this.slider.scrollTop : this.slider.scrollLeft;
    const i = e => {
      if (this.isCrawling) {
        if (null !== t) {
          const i = e - t, r = this.crawlSpeed * i / 1e3;
          s += r;
          const l = Math.floor(s);
          if (l !== (this.isVertical ? this.slider.scrollTop : this.slider.scrollLeft) && (this.isVertical ? this.slider.scrollTop = l : this.slider.scrollLeft = l), 
          this.loop) {
            const t = this.getSlideSize(), i = (this.loopOffset + this.realSlideCount) * t;
            if (s >= i) {
              const i = this.realSlideCount * t;
              s -= i, this.isVertical ? this.slider.scrollTop = Math.floor(s) : this.slider.scrollLeft = Math.floor(s);
            }
          }
        }
        t = e, this.crawlRafId = requestAnimationFrame(i);
      }
    };
    this.crawlRafId = requestAnimationFrame(i);
  }
  stopCrawl() {
    if (!this.isCrawling) return;
    this.isCrawling = !1, this.crawlRafId && (cancelAnimationFrame(this.crawlRafId), 
    this.crawlRafId = null), this.slider.style.scrollSnapType = "", this.slider.style.scrollBehavior = "";
    const t = this.getSlideSize(), s = this.isVertical ? this.slider.scrollTop : this.slider.scrollLeft, i = Math.round(s / t);
    this.isVertical ? this.slider.scrollTo({
      top: i * t,
      behavior: "smooth"
    }) : this.slider.scrollTo({
      left: i * t,
      behavior: "smooth"
    }), this.update();
  }
});